import { useTranslation } from "react-i18next"
import { useGetAboutQuery } from "../../../../backoffice/apis/aboutAPI";
import React, { useMemo } from "react";
import { Loading } from "../../../views/Loading";
import { ErrorComponent } from "../../../views/ErrorComponent";
import { Col, Container, Row } from "reactstrap";

export default function AboutPage(
    {
        isOpen
    }: {
        isOpen: boolean
    }
) {
    const { t } = useTranslation(["about", "common"]);

    const { data: aboutData, isLoading: aboutDataLoading, error: aboutDataError} = useGetAboutQuery(undefined, { skip: !isOpen, refetchOnMountOrArgChange: true})
    const baseUrl = useMemo(() => process.env.REACT_APP_BASE_URL, []);
    const version = useMemo(() => process.env.REACT_APP_VERSION, []);
    const name = useMemo(() => process.env.REACT_APP_NAME, []);

    let apiAbout: JSX.Element
    if (aboutDataLoading) {
        apiAbout = (
            <>
                <Loading className="m-4" />
            </>
        )
    } else if (aboutDataError) {
        apiAbout = (
            <>
                <ErrorComponent error='Failed to fetch data.' />
            </>
        )
    } else if (aboutData) {
        apiAbout = (
            <>
                <Row>
                    <Col lg={4}>
                        {t("Api Version")}
                    </Col>
                    <Col>
                        {aboutData.apiVersion}
                    </Col>
                </Row>
            </>
        )
    } else {
        apiAbout = (
            <>
                <ErrorComponent error='No failure found but data failed to fetch.' />
            </>
        )
    }


    return (
        <Container>
            <Row>
                <Col className="d-flex flex-column justify-content-center">
                    <img src={process.env.REACT_APP_LOGO} className="w-100 mb-4" />
                </Col>
                <Col className="d-flex flex-column justify-content-center">
                    <img src="/images/mik3logo.png" className="w-100 mb-4" />
                </Col>
            </Row>
            <Row>
                <Col lg={4}>
                    {t("Client Name")}
                </Col>
                <Col>
                    {name}
                </Col>
            </Row>
            <Row>
                <Col lg={4}>
                    {t("Client Version")}
                </Col>
                <Col>
                    {version}
                </Col>
            </Row>
            <Row>
                <Col lg={4}>
                    {t("Api base url")}
                </Col>
                <Col>
                    {baseUrl}
                </Col>
            </Row>
            {apiAbout}
        </Container>
    )
}